import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'importer-organisation-management',
  templateUrl: './organisation_management.component.html',
  styleUrls: ['./organisation_management.component.scss'],
  standalone: false
})
export class OrganisationManagementComponent {
  private router = inject(Router);

  openList: 'transfer' | 'structure' | 'email';

  constructor() {
    this.openList = 'transfer';
  }

  openTransferListPage() {
    this.openList = 'transfer';
    this.router.navigate([]);
  }
  openStructureListPage() {
    this.openList = 'structure';
    this.router.navigate([]);
  }
  openEmailListPage() {
    this.openList = 'email';
    this.router.navigate([]);
  }
}
